import { Flex, Icon, Tooltip, Typography } from '@aloft/toolkit-sui';
import { Spinner } from '@aloft/toolkit-sui/chakra';

export type AnalysisLabelProps = {
  state: 'loading' | 'error' | 'success';
  tooltip: string;
  recommend?: string;
};

export function AnalysisLabel({ state, tooltip, recommend }: AnalysisLabelProps) {
  return (
    <Tooltip label={tooltip}>
      <Flex flexDirection="row" gap={1} alignItems="center">
        <Icon icon="sparkle" size="sm" />
        {state === 'loading' && <Spinner size="xs" />}
        {state === 'error' && <Icon icon="error-warning" size="sm" />}
        {state === 'success' && (
          <Typography inline variant="body2">
            {recommend ?? '-'}
          </Typography>
        )}
      </Flex>
    </Tooltip>
  );
}
